// 全域強制升級覆蓋頁（20 §8.2 / 00 §4.2）。
// 任一 REST 回 426 UPGRADE_REQUIRED → api.ts 觸發 onUpgradeRequired → 本覆蓋頁。
// 不可關閉（client 版本已低於 force_upgrade_below，繼續使用無意義）；
// web 的「導商店」= 重新整理取最新建置（11 §3.3 build-time 版本）。

import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { onUpgradeRequired } from '../lib/api';

export function ForceUpgradeOverlay() {
  const { t } = useTranslation();
  const [required, setRequired] = useState(false);

  useEffect(() => {
    onUpgradeRequired(() => setRequired(true));
    return () => onUpgradeRequired(null);
  }, []);

  if (!required) return null;

  return (
    <div
      role="alertdialog"
      aria-modal="true"
      aria-label={t('shell.upgrade.title')}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.7)',
        display: 'grid',
        placeItems: 'center',
        zIndex: 2000,
        padding: 'var(--spacing-8)',
      }}
    >
      <section className="card" style={{ maxWidth: 420, textAlign: 'center' }}>
        <h1 style={{ marginTop: 0, fontSize: 'var(--font-size-3xl)' }}>{t('shell.upgrade.title')}</h1>
        <p className="text-secondary">{t('shell.upgrade.body')}</p>
        <button className="btn-primary" onClick={() => window.location.reload()}>
          {t('common.refresh')}
        </button>
      </section>
    </div>
  );
}
